import DataTile from "./DataTile";
import React from "react";
import {useSelector} from "react-redux";
import {
    BBObjectCounter,
    bbTranslateBreachRiskScoreToCategory,
    filterObject,
} from "../../../util/bbHelpers";
import CustomActiveShapePieChart from "../charts/CustomActiveShapePieChart";


const Tile = ({
    useTheseEntitiesInstead = false,
    slimView = false
              }) => {

    // const {customerId} = props;

    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const {customers, customerInView, selfEntityId} = useSelector(({customer}) => customer);

    // const {portfolios, loadingPortfolios, loadingPortfoliosError, selfEntityId, loadingCycleDetails, loadingCycleDetailsError} = useSelector(({breachrisk}) => breachrisk);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;


    // const colorFunction = (stateData) => {
    //     return "light";
    // }

    // const getHighRiskServices = (servicesArray) => {
    //     return servicesArray.filter(service => bbIsServiceHighRisk(service)).length
    // }

    const showPieWith = (stateData) => {
        if (stateData && stateData[customerIdToUse]) {

            try {

                const entities = stateData
                && customerInView
                && stateData[customerIdToUse]
                    ? filterObject(stateData[customerIdToUse].entities, (_, entity) => entity.id !== selfEntityId)
                    : null;

                const entityDataSetToUse = useTheseEntitiesInstead ? useTheseEntitiesInstead : entities;
                // console.log("Pie chart slim view in main function", slimView, "useTheseEntitiesInstead", useTheseEntitiesInstead)


                //go through the activeServicesDetails and count ocurrance of each service name

                const arrayOfEntities = Object.keys(entityDataSetToUse).map((k) => entityDataSetToUse[k]).filter(entity => !!entity.last_cycle);
                const chartData = []
                const results = arrayOfEntities && new BBObjectCounter(arrayOfEntities, x => bbTranslateBreachRiskScoreToCategory(parseFloat(x.last_cycle.score).toFixed(1)));
                for (let [category, occurrances] of results.entries()) {
                    // console.log("here is the for loop of services", service)
                    chartData.push(
                        {
                            name: `${category} Risk`,
                            value: occurrances
                        }
                    )
                }
                    // console.log("chartData", chartData)

                    return <div
                        // id={"tourRiskDistributionPieChart"}
                        className={"animated fadeIn animation-duration-7"}
                        style={{ marginTop: -40, marginBottom: -15 }}
                    ><CustomActiveShapePieChart
                        data = {chartData}
                        // riskBy5={translateValueToRisk(valueFunction(stateData))}
                        useRiskCategoryColors
                    /></div>


            } catch(e) {
                console.warn(e);
                return null
            }
        } else {
            return null
        }
    }

    // const translateValueToRisk = (value) => {
    //     if (typeof value !== "number") {
    //         return null
    //     } else if (value <= 0) {
    //         return 0
    //     } else if (value <= 2) {
    //         return 1
    //     } else if (value <= 5) {
    //         return 2
    //     } else if (value <= 15) {
    //         return 3
    //     } else {
    //         return 4
    //     }
    // }

    // const riskRibbon = (stateData) => {
    //     const num = translateValueToRisk(valueFunction(stateData));
    //     return num
    //         ? <RiskRibbon ratingBy5={num} />
    //         : null;
    // }

    // const valueFunction = (stateData) => stateData ? stateData[customerIdToUse] ? stateData[customerIdToUse].active_services_list.filter(service => bbIsServiceHighRisk(service)).length : null : null;

    const valueFunction = (stateData) => {
        // const entities = stateData
        // && customerInView
        // && stateData[customerIdToUse]
        //     ? filterObject(stateData[customerIdToUse].entities, (_, entity) => entity.id !== selfEntityId)
        //     : null;
        //
        // //go through the activeServicesDetails and count ocurrance of each service name
        //
        // const arrayOfEntities = entities ? Object.keys(entities).map((k) => entities[k]).filter(entity => !!entity.last_cycle) : null;
        //
        // if (arrayOfEntities && arrayOfEntities.length > 0) {
        //     const arrayOfHighRiskEntities = arrayOfEntities.filter(entity => entity.last_cycle.score >= 6.0);
        //     const dataPointToDisplay = Math.ceil(parseFloat(arrayOfHighRiskEntities.length / arrayOfEntities.length * 100));
        //
        //     return `${dataPointToDisplay}%`;
        // } else {
        //     return "No scores collected yet."
        // }

        console.log("Pie chart slim view", slimView)

        return slimView ? null : "Risk Distribution"


    }

    return (
        <DataTile
            // color = {colorFunction()}
            // colorBgFunction={colorFunction}
            id={"tourRiskDistributionPieChart"}
            subTitle={slimView ? null : `All Companies by Risk Category`}
            tipText={`Risk category distribution of all portfolio companies that have received at least one BreachRisk™ Score.`}
            icon={<div
                className={"animated fadeIn animation-duration-7"}
                style={{ marginTop: -40, marginBottom: -15 }}
            ><CustomActiveShapePieChart
                data = {[]}
                // riskBy5={-1}
                loading
            /></div>}
            iconFunction = {showPieWith}
            iconClasses={" "}
            stateName="breachrisk"
            stateElement="portfolios"
            //useDeepDataStore
            dontFetch
            // forceLoadingState = {myEntity && myEntity.settings && myEntity.settings.last_cycle_id && !loadingCycleDetails[myEntity.settings.last_cycle_id] && techData ? false : true}
            // useDeepDataStore
            // dontFetch
            // forceLoadingState = {true}
            // deepDataStore = {(dataStore) => dataStore? dataStore[customerIdToUse] ? dataStore[customerIdToUse] : null : null}
            // stateLoaderName="loadingTargets"
            // stateLoaderError="loadingTargetsError"
            // stateFetchAction={fetchTargets(
            //     {
            //         customerId: customerIdToUse
            //     }
            // )}
            // preventDataFetchConditionFunction={(dataStore) => !customerIdToUse}
            valueFunction={valueFunction}
            // ribbonFunction={riskRibbon}
            // requiresModule={"monitor"}
        />
    )

}

export default Tile;